import TransitionExpand from './transition-expand';

export {
	TransitionExpand,
};



// WEBPACK FOOTER //
// ../shared/animations/index.js